// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2561":"fa9940f932d4c151","3185":"27123322c4e263c6","3366":"2a39a50648192d31"}[chunkId] + ".css";
};